import React from 'react';
import {
	ColorPicker,
	FormGroup,
	Input,
	FormControl,
	Dropdown,
	CustomText,
    RichEditor,
    Icon,
    ButtonSelect,
} from 'components';
import { BADGES_POSITIONS } from 'lib/globals'
import styles from 'styles/cart_screen.module.scss';


const BadgesSettings = ({shopContext, }) => {

	const { state, setItem } = shopContext;
	const { scary } = state.settings

    const handleCheck = (event, name) => {
		setItem( `settings.scary.${name}`, event.target.checked);
	}

	const handleRadio = (value, name) => {
		setItem( `settings.scary.${name}`, value);
	}

    return (
        
        <FormGroup 
            label="Trust Badges / images" 
            info={`Increase trust with a secure checkout message and payment badges.
            You can use the ones we provide or upload your own. 
            (Suggested image size = 50kb or less)`}
            >
            <FormControl
                label="Position in Cart Drawer"
                withSwitch={[shopContext, "settings.badges.isActive"]}
            >
                <Dropdown
                    options={BADGES_POSITIONS}
                    first
                    BindToContext={[shopContext, "settings.badges.position"]}
                />
            </FormControl>
            <FormControl >
                <RichEditor
                    placeholder="payement badges"
                    BindToContext={[shopContext, "settings.badges.value"]}
                />
            </FormControl>
        </FormGroup>

    )
}


export  {BadgesSettings};